var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResumeLibraryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33073 4.0013H0.664062V15.668C0.664062 16.5846 1.41406 17.3346 2.33073 17.3346H13.9974V15.668H2.33073V4.0013ZM15.6641 0.667969H5.66406C4.7474 0.667969 3.9974 1.41797 3.9974 2.33464V12.3346C3.9974 13.2513 4.7474 14.0013 5.66406 14.0013H15.6641C16.5807 14.0013 17.3307 13.2513 17.3307 12.3346V2.33464C17.3307 1.41797 16.5807 0.667969 15.6641 0.667969ZM15.6641 12.3346H5.66406V2.33464H15.6641V12.3346ZM7.33073 6.5013H13.9974V8.16797H7.33073V6.5013ZM7.33073 9.0013H10.6641V10.668H7.33073V9.0013ZM7.33073 4.0013H13.9974V5.66797H7.33073V4.0013Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeLibraryIcon);
export default __webpack_public_path__ + "static/media/ResumeLibraryIcon.313300f90a1b57259439555987f9f37c.svg";
export { ForwardRef as ReactComponent };